module.exports = __webpack_public_path__ + "static/media/nt-3.47c2a444.png";